import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { AiOutlineFileText, AiOutlineFileExcel } from "react-icons/ai";
import { FaExternalLinkAlt } from "react-icons/fa";

function LibraryBooks() {
  const [books] = useState([
    { id: 1, title: "Library Books List", author: "VBU MCA Library", type: "PDF", link: "/docs/Libarary Books Details.pdf" },
  ]);

  const eResources = [
    { 
      name: "INFLIBNET", 
      desc: "Information and Library Network Centre - Access to e-ShodhSindhu and more.", 
      url: "https://idp.inflibnet.ac.in/", 
      logo: "/Images/inflibnet.png" 
    },
    { 
      name: "National Digital Library (NDL)", 
      desc: "A single-window facility that collects and collates metadata and provide full text index.", 
      url: "https://www.ndl.gov.in/", 
      logo: "/Images/ndl.png" 
    },
    { 
      name: "ONOS - One Nation One Subscription", 
      desc: "Government of India's initiative providing access to research journals and publications across the nation.", 
      url: "https://www.onos.gov.in/publishers", 
      logo: "/Images/onos.png" 
    }
  ];

  return (
    <>
      <Helmet>
        <title>Library Resources - VBU MCA</title>
      </Helmet>
      <div className="PageContainer">
        <div id="Heading">
          <h1>Library Resources</h1>
        </div>

        <div className="LibraryBooksSection" data-aos="fade-up">
          <p className="SectionIntro">
            Explore our physical collection and digital gateways providing unlimited access to academic journals, e-books, and research databases.
          </p>

          {/* E-Resources Section */}
          <div className="EResourcesSection" data-aos="fade-up">
            <h2 className="SubSectionTitle">E-Resources & Portals</h2>
            <div className="EResourcesGrid">
              {eResources.map((res, idx) => (
                <div key={idx} className="EResourceCard">
                  <div className="EResourceLogo">
                    <img src={res.logo} alt={res.name} />
                  </div>
                  <div className="EResourceInfo">
                    <h3>{res.name}</h3>
                    <p>{res.desc}</p>
                    <a href={res.url} target="_blank" rel="noreferrer" className="VisitBtn">
                      Access Portal <FaExternalLinkAlt size={12} style={{marginLeft: '7px'}} />
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <hr className="SectionDivider" />

          {/* Books List Section */}
          <div className="BooksListSection" data-aos="fade-up">
            <h2 className="SubSectionTitle">Digital Catalogs & Book Lists</h2>
            <div className="BooksGrid">
              {books.map((book) => (
                <div key={book.id} className="BookCard">
                  <div className="BookIcon">
                    {book.type === "PDF" ? <AiOutlineFileText color="#ff4d4d" size={40} /> : <AiOutlineFileExcel color="#2ecc71" size={40} />}
                  </div>
                  <div className="BookInfo">
                    <h4>{book.title}</h4>
                    <p>{book.author}</p>
                    <span className={`TypeBadge ${book.type.toLowerCase()}`}>{book.type}</span>
                  </div>
                  <div className="BookAction">
                    <a href={book.link} target="_blank" rel="noreferrer" className="ViewBtn">View Resource</a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .LibraryBooksSection {
          display: flex;
          flex-direction: column;
          gap: 40px;
          margin-top: 20px;
          max-width: 1200px;
          margin-left: auto;
          margin-right: auto;
          padding: 0 0 50px 0;
        }
        .SectionIntro {
          font-size: 1.15rem;
          color: #555;
          margin-bottom: 30px;
          line-height: 1.6;
          text-align: center;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }
        .SubSectionTitle {
          font-size: 1.6rem;
          color: #1a237e;
          margin-bottom: 25px;
          text-align: center;
          font-weight: 700;
        }
        .SectionDivider {
          border: none;
          height: 1px;
          background: #eee;
          margin: 40px 0;
        }
        
        /* E-Resources Grid */
        .EResourcesGrid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 25px;
        }
        .EResourceCard {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 20px;
          background: #fff;
          padding: 30px 20px;
          border-radius: 15px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.06);
          border: 1px solid #f0f0f0;
          transition: transform 0.3s ease;
          height: 100%;
        }
        .EResourceCard:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.1);
          border-color: #1a237e;
        }
        .EResourceLogo {
          width: 120px;
          height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fcfcfc;
          border-radius: 8px;
          padding: 10px;
          border: 1px solid #f0f0f0;
        }
        .EResourceLogo img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .EResourceInfo {
          display: flex;
          flex-direction: column;
          align-items: center;
          flex: 1;
        }
        .EResourceInfo h3 {
          margin: 0 0 12px 0;
          color: #333;
          font-size: 1.25rem;
          font-weight: 700;
        }
        .EResourceInfo p {
          margin: 0 0 20px 0;
          font-size: 0.9rem;
          color: #666;
          line-height: 1.5;
          min-height: 3em;
        }
        .VisitBtn {
          display: inline-flex;
          align-items: center;
          padding: 10px 20px;
          background: #1a237e;
          color: #fff !important;
          border-radius: 8px;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          margin-top: auto;
        }
        .VisitBtn:hover {
          background: #3949ab;
          transform: translateY(-2px);
        }

        /* Books List Grid */
        .BooksGrid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
          gap: 30px;
        }
        .BookCard {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          background: #fff;
          padding: 35px 25px;
          border-radius: 15px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: all 0.3s ease;
          border: 1px solid #f0f0f0;
          height: 100%;
        }
        .BookCard:hover {
          transform: translateY(-8px);
          box-shadow: 0 15px 40px rgba(0,0,0,0.1);
          border-color: #1a237e;
        }
        .BookIcon {
          margin-bottom: 20px;
          display: flex;
          justify-content: center;
        }
        .BookInfo {
          flex: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 12px;
          margin-bottom: 25px;
        }
        .BookInfo h4 {
          margin: 0;
          color: #2c3e50;
          font-size: 1.25rem;
          font-weight: 700;
        }
        .BookInfo p {
          margin: 0;
          font-size: 0.95rem;
          color: #7f8c8d;
        }
        .TypeBadge {
          display: inline-block;
          padding: 5px 15px;
          border-radius: 6px;
          font-size: 0.75rem;
          font-weight: 800;
          text-transform: uppercase;
        }
        .pdf { background: #fff5f5; color: #e74c3c; border: 1px solid #ffdada; }
        .excel { background: #f0fff4; color: #27ae60; border: 1px solid #c6f6d5; }
        .BookAction {
          width: 100%;
        }
        .ViewBtn {
          display: block;
          width: 100%;
          padding: 12px;
          background: #1a237e;
          color: #fff !important;
          border-radius: 10px;
          font-size: 0.95rem;
          font-weight: 600;
          transition: all 0.3s ease;
          text-align: center;
        }
        .ViewBtn:hover {
          background: #303f9f;
        }

        @media (max-width: 768px) {
          .EResourceCard {
            flex-direction: column;
            text-align: center;
            padding: 25px;
          }
          .EResourcesGrid {
            grid-template-columns: 1fr;
          }
          .BooksGrid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
}

export default LibraryBooks;
